import 'css-chunksrc/client/scenes/constrainElement/startEndForm/styles.scss';export default {
  "form": "_form_rh8wx_1"
};